import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { useNavigate, Link } from "react-router-dom";
import { Button } from "antd";
import logoImg from "../../assets/images/logo-img.png";
import footerCompanyLogo1 from "../../assets/images/AGS.png";
import "../../assets/css/login-cinematic.css";
import { useTranslation } from "react-i18next";

const PrivacyStatement = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const WhiteLabeling = useSelector((state) => state.loginReducer);
  const [showScrollTop, setShowScrollTop] = useState(false);
  const [isLightMode, setIsLightMode] = useState(() => {
    if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
      return false;
    }
    return true;
  });
  const contentRef = useRef(null);

  useEffect(() => {
    const el = contentRef.current;
    if (!el) return;
    const handleScroll = () => setShowScrollTop(el.scrollTop > 300);
    el.addEventListener("scroll", handleScroll);
    return () => el.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    const handleChange = (e) => setIsLightMode(!e.matches);
    
    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener('change', handleChange);
      return () => mediaQuery.removeEventListener('change', handleChange);
    } else if (mediaQuery.addListener) {
      mediaQuery.addListener(handleChange);
      return () => mediaQuery.removeListener(handleChange);
    }
  }, []);

  const handleOpenLink = (link) => window.open(link, "__blank");

  return (
    <div className={isLightMode ? "light-theme" : ""} style={{ height: "100vh", background: isLightMode ? "#f8fafc" : "#0f172a", display: "flex", flexDirection: "column", overflow: "hidden", color: isLightMode ? "#0f172a" : "#f8fafc", fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif" }}>
      {/* Header */}
      <header className="login-cinematic-top-header" style={{ position: 'relative', flexShrink: 0, padding: '0 40px', background: '#0f172a' }}>
        <img
          src={WhiteLabeling?.whiteLebelData?.[0]?.logoImage || logoImg}
          alt="Logo"
          className="top-header-logo"
          onClick={() => navigate("/")}
        />
        
        <div style={{ position: 'absolute', left: '50%', transform: 'translateX(-50%)' }}>
          <span className="legal-page-title" style={{ color: "#94a3b8" }}>Privacy Statement</span>
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
          <Button className="legal-back-btn" onClick={() => navigate(-1)} style={{ color: "#f8fafc", borderColor: "#334155", background: '#1e293b' }}>
            <i className="fa fa-arrow-left" style={{ marginRight: 6, fontSize: 13 }} />
            Back
          </Button>
        </div>
      </header>

      {/* Scrollable Content */}
      <div
        ref={contentRef}
        style={{
          flex: 1,
          overflowY: "auto",
          minHeight: 0,
          padding: "2rem 2.5rem",
        }}
      >
        <div
          style={{ maxWidth: 900, margin: "0 auto" }}
          dangerouslySetInnerHTML={{
            __html: WhiteLabeling?.whiteLebelData?.[0]?.privacy_Statement,
          }}
        />
      </div>

      {/* Scroll-to-top FAB */}
      {showScrollTop && (
        <button
          onClick={() => contentRef.current?.scrollTo({ top: 0, behavior: "smooth" })}
          style={{
            position: "fixed", bottom: "80px", right: "24px",
            background: "#1e293b", border: "1px solid #334155",
            borderRadius: "50%", width: "42px", height: "42px",
            color: "#94a3b8", cursor: "pointer", fontSize: "18px",
            display: "flex", alignItems: "center", justifyContent: "center",
            zIndex: 50,
          }}
        >
          <i className="fa fa-arrow-up" />
        </button>
      )}

      {/* Footer */}
      <footer className="login-cinematic-footer" style={{ flexShrink: 0 }}>
        <div className="login-cinematic-footer-links">
          <img
            src={WhiteLabeling?.whiteLebelData?.[0]?.footerLogo || footerCompanyLogo1}
            alt="Logo"
            style={{ height: "18px", filter: "brightness(0) invert(1)", cursor: "pointer" }}
            onClick={() => handleOpenLink(WhiteLabeling?.whiteLebelData?.[0]?.footerLogoLink || "")}
          />
          <Link to={"/termsOfService"}>{t("Terms of Service")}</Link>
          <Link to={"/privacyStatement"}>{t("Privacy Statement")}</Link>
        </div>
        <div>
          Copyright {new Date().getFullYear()} {WhiteLabeling?.whiteLebelData?.[0]?.name || "JewelCloud"}
        </div>
      </footer>
    </div>
  );
};

export default PrivacyStatement;
